import {useState} from "react";
import ExerciserTopContentLayout from "../../layouts/courses/exercisers/ExerciserTopContentLayout";
import ExerciserQuestionText from "../../texts/courses/exercisers/ExerciserQuestionText";
import ExerciserSingleValueAnswerInput from "../../inputs/exercisers/ExerciserSingleValueAnswerInput";
import ExerciserBottomContentLayout from "../../layouts/courses/exercisers/ExerciserBottomContentLayout";
import {PositiveDecimalKeyboard} from "../../keyboards/PositiveDecimalKeyboard";
import ExerciserBottomBar from "../../bars/courses/exercisers/ExerciserBottomBar";
import {getLocalItemAsJsonFromKey, setLocalItemFromKey} from "../../../services/LocalStorage";
import {kSystemKeys} from "../../../constants/keys";
import {trimTrailingZerosInDecimals} from "../../../helpers/StringHelper";

export default function Exerciser76({ problem,
                                       setIsExerciserOver,
                                       currentIndex,
                                       setCurrentIndex }) {
    // Referenced in activeExercisers to handle LevelA76
    // exercisers
    // UID : 76
    // Grade : CM1
    // Task : Multiplier un nombre par 100
    // Notes : N/A

    // PROPERTIES
    const answerMaxLength = 7
    const [userAnswer, setUserAnswer] = useState("");

    // BUILD
    return (
        <div className={"grow w-full flex flex-col justify-start items-center"}>
            <ExerciserTopContentLayout>
                <ExerciserQuestionText question={problem?.questions[currentIndex].question} />
                <ExerciserSingleValueAnswerInput value={userAnswer}
                                                 placeholder={"ex : 124"} />
            </ExerciserTopContentLayout>
            <ExerciserBottomContentLayout>
                <PositiveDecimalKeyboard onKeyButtonPressed={onKeyButtonPressed}
                                         isKeyButtonDisabled={isKeyButtonDisabled} />
                <ExerciserBottomBar isEraseButtonDisabled={isEraseButtonDisabled()}
                                    onEraseButtonPressed={onEraseButtonPressed}
                                    isValidationButtonDisabled={isValidateButtonDisabled()}
                                    onValidateButtonPressed={onValidateButtonPressed} />
            </ExerciserBottomContentLayout>
        </div>
    );

    // METHODS
    // <<<< Erase button >>>>
    // ---- UX : Check if erase button is disabled
    function isEraseButtonDisabled() {
        return userAnswer.length === 0
    }

    // ---- LOGIC : On erase button pressed
    function onEraseButtonPressed() {
        setUserAnswer((prev) => (prev.length > 0 ? prev.slice(0, -1) : ""));
    }

    // <<<< Validation button >>>>
    // ---- UX : Check if validate button is disabled
    function isValidateButtonDisabled() {
        return !userAnswer || userAnswer.trim() === "" || userAnswer.slice(-1) === ",";
    }

    // ---- LOGIC : On validate button pressed
    function onValidateButtonPressed() {
        // Defense
        if (isValidateButtonDisabled())
            return

        // Process answer
        const normalizedAnswer = trimTrailingZerosInDecimals(userAnswer)
        // ---- Create userSubmission object
        const userSubmission = {
            answer: normalizedAnswer,
            isCorrect: normalizedAnswer === problem.questions[currentIndex].answer
        }
        // ---- Add user answer object to problem
        problem.questions[currentIndex] = {...problem.questions[currentIndex], userSubmission: userSubmission}
        // ---- LOCAL STORAGE : Update problem
        let localSession = getLocalItemAsJsonFromKey(kSystemKeys.session)
        localSession = {...localSession, problem: problem}

        // Navigate to next step
        if (currentIndex === problem?.questions?.length - 1) {
            // Case : it was last problem
            setIsExerciserOver(true)
            localSession = {...localSession, isExerciserOver: true}
        } else {
            // Case : question(s) left
            // ---- Reset state and increment currentIndex
            setUserAnswer("")
            const newCurrentIndex = currentIndex + 1;
            setCurrentIndex(newCurrentIndex)
            localSession = {...localSession, currentQuestion: newCurrentIndex}
        }
        // LOCAL STORAGE : Update local session
        setLocalItemFromKey(kSystemKeys.session, localSession)
    }

    // <<<< Key button >>>>
    // ---- UX : Check if key button is disabled
    function isKeyButtonDisabled(item) {
        if (userAnswer.length >= answerMaxLength)
            return true
        if (item === ',') {
            return userAnswer.length === 0 || userAnswer.includes(",")
        } else {
            // Case : Numbers keys
            return userAnswer[0] === "0" && userAnswer.length === 1;
        }
    }

    // ---- LOGIC : On key button pressed
    function onKeyButtonPressed(item) {
        if (!isKeyButtonDisabled(item)) {
            setUserAnswer((prev) => prev + item)
        }
    }
}